import { api } from "@/lib/api";

export const PRODUCT_LABELS = {
  download: "Digital Download",
  course: "Online Course",
  membership: "Membership",
  booking: "Booking",
  lead_magnet: "Lead Magnet",
};

export const PRODUCT_ICONS = {
  download: "📘",
  course: "🎓",
  membership: "🔑",
  booking: "📅",
  lead_magnet: "🌤️",
};

export const PRODUCT_KINDS = [
  "download",
  "course",
  "membership",
  "booking",
  "lead_magnet",
];

export const TEMPLATE_LABELS = {
  medspa: "Medspa - Founding Client Vault",
  agency: "Agency - Productized Playbooks",
  coach: "Coach - Signature Method Store",
};

// --- API helpers ---
export const monetize = {
  meta: () => api.get("/monetize/meta").then((r) => r.data),
  analytics: () => api.get("/monetize/analytics").then((r) => r.data),
  listStorefronts: () => api.get("/monetize/storefronts").then((r) => r.data),
  getStorefront: (id) => api.get(`/monetize/storefronts/${id}`).then((r) => r.data),
  createStorefront: (payload) =>
    api.post("/monetize/storefronts", payload).then((r) => r.data),
  patchStorefront: (id, payload) =>
    api.patch(`/monetize/storefronts/${id}`, payload).then((r) => r.data),
  deleteStorefront: (id) => api.delete(`/monetize/storefronts/${id}`),
  createProduct: (sid, payload) =>
    api.post(`/monetize/storefronts/${sid}/products`, payload).then((r) => r.data),
  patchProduct: (pid, payload) =>
    api.patch(`/monetize/products/${pid}`, payload).then((r) => r.data),
  deleteProduct: (pid) => api.delete(`/monetize/products/${pid}`),
  orders: () => api.get("/monetize/orders").then((r) => r.data),
  aiGenerate: (payload) =>
    api.post("/monetize/ai/generate", payload).then((r) => r.data),
  affiliates: () => api.get("/monetize/affiliates").then((r) => r.data),
  createAffiliate: (payload) =>
    api.post("/monetize/affiliates", payload).then((r) => r.data),
  // Public (no auth)
  publicStorefront: (slug) =>
    api.get(`/monetize/public/${slug}`).then((r) => r.data),
  publicCheckout: (slug, payload) =>
    api.post(`/monetize/public/${slug}/checkout`, payload).then((r) => r.data),
};

export function formatPrice(cents, currency = "USD", interval = "one_time") {
  if (cents === 0) return "Free";
  const amt = (cents / 100).toLocaleString("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  });
  if (interval === "month") return `${amt}/mo`;
  if (interval === "year") return `${amt}/yr`;
  return amt;
}
